/**
 * Piezas del Estanque — generado a partir de src/assets/estanque/ (SVG del
 * diseñador). No editar a mano: si cambian los SVG, regenerar desde ellos.
 *
 * Cada entrada es el contenido de un SVG de casilla con viewBox "0 0 100 100".
 * Los cuerpos de los peces se salen adrede del cuadrado (de -4 a 104) y el
 * propio <svg> de la casilla los recorta, que es lo que hace que dos casillas
 * contiguas encajen sin junta visible.
 */
import { ReactElement } from 'react';

export const PIEZAS: Record<string, ReactElement> = {
  "grande/horizontal/cabeza": (
    <><path d="M64 30 L56 10 L82 26 Z M64 70 L56 90 L82 74 Z" fill="#EE7B30" opacity="0.85"/>
<path d="M104 28 L62 28 C28 28 12 40 12 50 C12 60 28 72 62 72 L104 72" fill="#FFF7EE" stroke="#D9A27A" strokeWidth="2.5"/>
<path d="M62 28 C28 28 12 40 12 50 C12 60 28 72 62 72 C53 60 53 40 62 28 Z" fill="#EE7B30"/>
<circle cx="30" cy="42" r="4.5" fill="#2A1A10"/><circle cx="30" cy="58" r="4.5" fill="#2A1A10"/>
<path d="M14 46 C7 41 5 35 7 29 M14 54 C7 59 5 65 7 71" stroke="#B4531A" strokeWidth="2.5" fill="none" strokeLinecap="round"/></>
  ),
  "grande/horizontal/central-a": (
    <><rect x="-4" y="28" width="108" height="44" fill="#FFF7EE" stroke="#D9A27A" strokeWidth="2.5"/><ellipse cx="34" cy="42" rx="16" ry="10" fill="#EE7B30"/><ellipse cx="70" cy="60" rx="12" ry="8" fill="#EE7B30"/><rect x="40" y="46" width="18" height="4" rx="2" fill="#fff" opacity="0.6"/></>
  ),
  "grande/horizontal/central-b": (
    <><rect x="-4" y="28" width="108" height="44" fill="#FFF7EE" stroke="#D9A27A" strokeWidth="2.5"/><ellipse cx="52" cy="48" rx="22" ry="13" fill="#EE7B30"/><rect x="14" y="54" width="14" height="4" rx="2" fill="#F6D9C0"/></>
  ),
  "grande/horizontal/central-c": (
    <><rect x="-4" y="28" width="108" height="44" fill="#FFF7EE" stroke="#D9A27A" strokeWidth="2.5"/><ellipse cx="26" cy="58" rx="13" ry="9" fill="#EE7B30"/><ellipse cx="68" cy="40" rx="18" ry="9" fill="#EE7B30"/></>
  ),
  "grande/horizontal/cola": (
    <><path d="M-4 28 L36 34 L60 50 L36 66 L-4 72" fill="#FFF7EE" stroke="#D9A27A" strokeWidth="2.5"/>
<ellipse cx="16" cy="50" rx="10" ry="7" fill="#EE7B30"/>
<path d="M55 50 L94 18 C83 38 83 62 94 82 Z" fill="#EE7B30"/>
<path d="M61 50 L86 30 M61 50 L86 70 M61 50 L88 50" stroke="#000" strokeOpacity="0.18" strokeWidth="2" fill="none"/></>
  ),
  "grande/nenufar": (
    <><path d="M50 50 L86 40 A37 37 0 1 1 80 29 Z" fill="#78A565" stroke="#557F45" strokeWidth="3"/>
<path d="M50 50 L30 30 M50 50 L24 60 M50 50 L56 82" stroke="#557F45" strokeWidth="2"/>
<circle cx="36" cy="44" r="7" fill="#F4A6C0"/><circle cx="36" cy="44" r="3" fill="#FFE27A"/></>
  ),
  "grande/sin-forma": (
    <><ellipse cx="50" cy="50" rx="28" ry="20" fill="#FFF7EE" stroke="#EE7B30" strokeWidth="3" strokeDasharray="7 5"/><circle cx="50" cy="50" r="6" fill="#EE7B30"/></>
  ),
  "grande/vertical/cabeza": (
    <><g transform="rotate(90 50 50)"><path d="M64 30 L56 10 L82 26 Z M64 70 L56 90 L82 74 Z" fill="#EE7B30" opacity="0.85"/>
<path d="M104 28 L62 28 C28 28 12 40 12 50 C12 60 28 72 62 72 L104 72" fill="#FFF7EE" stroke="#D9A27A" strokeWidth="2.5"/>
<path d="M62 28 C28 28 12 40 12 50 C12 60 28 72 62 72 C53 60 53 40 62 28 Z" fill="#EE7B30"/>
<circle cx="30" cy="42" r="4.5" fill="#2A1A10"/><circle cx="30" cy="58" r="4.5" fill="#2A1A10"/>
<path d="M14 46 C7 41 5 35 7 29 M14 54 C7 59 5 65 7 71" stroke="#B4531A" strokeWidth="2.5" fill="none" strokeLinecap="round"/></g></>
  ),
  "grande/vertical/central-a": (
    <><g transform="rotate(90 50 50)"><rect x="-4" y="28" width="108" height="44" fill="#FFF7EE" stroke="#D9A27A" strokeWidth="2.5"/><ellipse cx="34" cy="42" rx="16" ry="10" fill="#EE7B30"/><ellipse cx="70" cy="60" rx="12" ry="8" fill="#EE7B30"/><rect x="40" y="46" width="18" height="4" rx="2" fill="#fff" opacity="0.6"/></g></>
  ),
  "grande/vertical/central-b": (
    <><g transform="rotate(90 50 50)"><rect x="-4" y="28" width="108" height="44" fill="#FFF7EE" stroke="#D9A27A" strokeWidth="2.5"/><ellipse cx="52" cy="48" rx="22" ry="13" fill="#EE7B30"/><rect x="14" y="54" width="14" height="4" rx="2" fill="#F6D9C0"/></g></>
  ),
  "grande/vertical/central-c": (
    <><g transform="rotate(90 50 50)"><rect x="-4" y="28" width="108" height="44" fill="#FFF7EE" stroke="#D9A27A" strokeWidth="2.5"/><ellipse cx="26" cy="58" rx="13" ry="9" fill="#EE7B30"/><ellipse cx="68" cy="40" rx="18" ry="9" fill="#EE7B30"/></g></>
  ),
  "grande/vertical/cola": (
    <><g transform="rotate(90 50 50)"><path d="M-4 28 L36 34 L60 50 L36 66 L-4 72" fill="#FFF7EE" stroke="#D9A27A" strokeWidth="2.5"/>
<ellipse cx="16" cy="50" rx="10" ry="7" fill="#EE7B30"/>
<path d="M55 50 L94 18 C83 38 83 62 94 82 Z" fill="#EE7B30"/>
<path d="M61 50 L86 30 M61 50 L86 70 M61 50 L88 50" stroke="#000" strokeOpacity="0.18" strokeWidth="2" fill="none"/></g></>
  ),
  "simplificada/horizontal/cabeza": (
    <><path d="M104 24 L60 24 C24 24 8 38 8 50 C8 62 24 76 60 76 L104 76" fill="#FFF7EE" stroke="#D9A27A" strokeWidth="4"/>
<path d="M60 24 C24 24 8 38 8 50 C8 62 24 76 60 76 C50 62 50 38 60 24 Z" fill="#EE7B30"/></>
  ),
  "simplificada/horizontal/central": (
    <><rect x="-4" y="24" width="108" height="52" fill="#FFF7EE" stroke="#D9A27A" strokeWidth="4"/><ellipse cx="50" cy="50" rx="20" ry="13" fill="#EE7B30"/></>
  ),
  "simplificada/horizontal/cola": (
    <><path d="M-4 24 L40 32 L58 50 L40 68 L-4 76" fill="#FFF7EE" stroke="#D9A27A" strokeWidth="4"/>
<path d="M52 50 L94 16 L94 84 Z" fill="#EE7B30"/></>
  ),
  "simplificada/nenufar": (
    <><path d="M50 50 L88 38 A39 39 0 1 1 82 26 Z" fill="#78A565" stroke="#557F45" strokeWidth="5"/></>
  ),
  "simplificada/sin-forma": (
    <><circle cx="50" cy="50" r="24" fill="#FFF7EE" stroke="#EE7B30" strokeWidth="8"/></>
  ),
  "simplificada/vertical/cabeza": (
    <><g transform="rotate(90 50 50)"><path d="M104 24 L60 24 C24 24 8 38 8 50 C8 62 24 76 60 76 L104 76" fill="#FFF7EE" stroke="#D9A27A" strokeWidth="4"/>
<path d="M60 24 C24 24 8 38 8 50 C8 62 24 76 60 76 C50 62 50 38 60 24 Z" fill="#EE7B30"/></g></>
  ),
  "simplificada/vertical/central": (
    <><g transform="rotate(90 50 50)"><rect x="-4" y="24" width="108" height="52" fill="#FFF7EE" stroke="#D9A27A" strokeWidth="4"/><ellipse cx="50" cy="50" rx="20" ry="13" fill="#EE7B30"/></g></>
  ),
  "simplificada/vertical/cola": (
    <><g transform="rotate(90 50 50)"><path d="M-4 24 L40 32 L58 50 L40 68 L-4 76" fill="#FFF7EE" stroke="#D9A27A" strokeWidth="4"/>
<path d="M52 50 L94 16 L94 84 Z" fill="#EE7B30"/></g></>
  ),
};

export const FONDOS: Record<string, ReactElement> = {
  "grande/descartada": (
    <><rect width="100" height="100" fill="#9FBAC4"/><path d="M24 40 q13 -9 26 0 q13 9 26 0" stroke="#4E6E79" strokeWidth="6" fill="none" strokeLinecap="round"/><path d="M24 62 q13 -9 26 0 q13 9 26 0" stroke="#4E6E79" strokeWidth="6" fill="none" strokeLinecap="round"/></>
  ),
  "grande/error": (
    <><rect width="100" height="100" fill="#FECACA"/></>
  ),
  "grande/intacta": (
    <><rect width="100" height="100" fill="#D3E2E7"/></>
  ),
  "grande/pista": (
    <><rect width="100" height="100" fill="#EDE9FE"/></>
  ),
  "grande/revelada": (
    <><rect width="100" height="100" fill="#FFF4D6"/></>
  ),
  "grande/revelada-agua": (
    <><rect width="100" height="100" fill="#FFF4D6"/><path d="M24 40 q13 -9 26 0 q13 9 26 0" stroke="#B45309" strokeWidth="6" fill="none" strokeLinecap="round"/><path d="M24 62 q13 -9 26 0 q13 9 26 0" stroke="#B45309" strokeWidth="6" fill="none" strokeLinecap="round"/></>
  ),
  "simplificada/descartada": (
    <><rect width="100" height="100" fill="#9FBAC4"/><path d="M22 50 q14 -11 28 0 q14 11 28 0" stroke="#4E6E79" strokeWidth="10" fill="none" strokeLinecap="round"/></>
  ),
  "simplificada/error": (
    <><rect width="100" height="100" fill="#FECACA"/></>
  ),
  "simplificada/intacta": (
    <><rect width="100" height="100" fill="#D3E2E7"/></>
  ),
  "simplificada/pista": (
    <><rect width="100" height="100" fill="#EDE9FE"/></>
  ),
  "simplificada/revelada": (
    <><rect width="100" height="100" fill="#FFF4D6"/></>
  ),
  "simplificada/revelada-agua": (
    <><rect width="100" height="100" fill="#FFF4D6"/><path d="M22 50 q14 -11 28 0 q14 11 28 0" stroke="#B45309" strokeWidth="10" fill="none" strokeLinecap="round"/></>
  ),
};

export const MARCOS: Record<string, ReactElement> = {
  "grande/error": (
    <><rect x="3" y="3" width="94" height="94" rx="6" fill="none" stroke="#EF4444" strokeWidth="6"/></>
  ),
  "grande/pista": (
    <><rect x="3" y="3" width="94" height="94" rx="6" fill="none" stroke="#7C3AED" strokeWidth="6" strokeDasharray="14 8"/></>
  ),
  "grande/revelada": (
    <><rect x="3" y="3" width="94" height="94" rx="6" fill="none" stroke="#B45309" strokeWidth="6"/></>
  ),
  "simplificada/error": (
    <><rect x="4" y="4" width="92" height="92" rx="8" fill="none" stroke="#EF4444" strokeWidth="9"/></>
  ),
  "simplificada/pista": (
    <><rect x="4" y="4" width="92" height="92" rx="8" fill="none" stroke="#7C3AED" strokeWidth="9"/></>
  ),
  "simplificada/revelada": (
    <><rect x="4" y="4" width="92" height="92" rx="8" fill="none" stroke="#B45309" strokeWidth="9"/></>
  ),
};
